import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { useTenantAreas } from '../lib/access/useTenantAreas';
/**
 * Phase 0.5 review fix: P0 — admin-only route guard for /admin/access.
 *
 * Earlier the page mounted under plain `ProtectedRoute` only, with a
 * stale comment claiming the route enforced an admin check. It did
 * not — any authenticated tenant member could load the page (and call
 * the Admin* RPCs directly bypassing the UI). The backend now rejects
 * non-admin principals (see services/enies-lobby/pkg/connecthandlers/
 * admin_authz.go::adminTenant), and this wrapper closes the UI side
 * so a non-admin user gets redirected instead of seeing an empty
 * "failed to load" page.
 *
 * The role list matches services/enies-lobby/pkg/connecthandlers/
 * admin_authz.go::AdminRoles. Keep in sync.
 */ const ADMIN_ROLES = new Set([
    'admin',
    'internal'
]);
export function RequireAdminRoute({ children, orCompanySettings = false }) {
    const { user, isLoading } = useAuth();
    const areas = useTenantAreas();
    if (isLoading || orCompanySettings && areas.isLoading) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex h-screen items-center justify-center bg-background",
            children: /*#__PURE__*/ _jsx("p", {
                className: "text-muted-foreground",
                children: "Loading…"
            })
        });
    }
    // Normalize case: user.role arrives lowercase from check-auth but uppercase
    // (EUserRoles) from the login response mapper — comparing raw would flip a
    // real admin to denied right after login. Lowercase both sides.
    const isAdmin = !!user?.role && ADMIN_ROLES.has(user.role.toLowerCase());
    if (!user || !(isAdmin || orCompanySettings && areas.companySettings)) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: "/dashboard",
            replace: true
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
